export default __webpack_public_path__ + "static/media/lilian1.d7f67048.jpg";